import {Vue} from 'vue';
import './messages.sass';
import Modal from '../../modal/src/modal';
import '../../../sass/_layout.sass';

Vue.component('messages-component', {
	data() {
		return {
			user: {
				avatar: String,
				status: String,
				bonuses: String
			},
			basket: Number,
			modal: null,
			portfolioShared: false,
			isMobile: false,
			showUserMenu: false,
			currentUserRole: '',
			scrollY: 0,
		};
	},
	template: `
    <div class="messages">
      <Modal v-if="modal" @close="closeModal">
        <template v-slot:body>
          <div class="modal-body__error">
            <svg v-if="modal.RESULT === 'error'" width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M50.5 88C71.2107 88 88 71.2107 88 50.5C88 29.7893 71.2107 13 50.5 13C29.7893 13 13 29.7893 13 50.5C13 71.2107 29.7893 88 50.5 88Z" fill="#FCC14B"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M53.5 32V29H47.5V32V56V59H53.5V56V32ZM53.5 69C53.5 70.6569 52.1569 72 50.5 72C48.8431 72 47.5 70.6569 47.5 69C47.5 67.3431 48.8431 66 50.5 66C52.1569 66 53.5 67.3431 53.5 69Z" fill="white"/>
            </svg>
            <svg v-else width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M50.5 88C71.2107 88 88 71.2107 88 50.5C88 29.7893 71.2107 13 50.5 13C29.7893 13 13 29.7893 13 50.5C13 71.2107 29.7893 88 50.5 88Z" fill="#7ED321"/>
				<path d="M70 38L43.9999 63L31 50.5" stroke="white" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
			</svg>
            <span>{{ modal.MESSAGE[0] }}</span>
            <span class="modal-body__submessage" v-if="modal.SUB_MESSAGE && modal.SUB_MESSAGE[0]">{{ modal.SUB_MESSAGE[0] }}</span>
          </div>
        </template>
      </Modal>
    </div>`,

	components: {
		Modal
	},

	methods: {
		closeModal() {
			if(this.modal.redirect) {
				location.href = this.modal.redirect;
			} else {
				this.modal = null;
			}
		},

		triggerError(object) {
			this.modal = object;
		},
	},

	created() {
		Vue.event.$on('triggerError', this.triggerError);
		if (window.TECE && window.TECE.MessageInfo && window.TECE.MessageInfo.MESSAGE.length) {
			this.modal = window.TECE.MessageInfo;
		}
	},

	mounted() {
		document.addEventListener('DOMContentLoaded', () => {
			if (!window.TECE_SHORT_USER) {
				const headerTitle = document.querySelectorAll('.profile-body__header');
				const profileBody = document.querySelector('.profile-body');
				if (profileBody) {
					profileBody.classList.add('profile-body--unauth');
				}
				if (headerTitle && headerTitle.length) {
					headerTitle.forEach(item => item.classList.add('profile-body__header--unauth'));
				}
			}
		});
	},

	beforeDestroy() {
		Vue.event.$off('triggerError', this.triggerError);
	},
});

import { BitrixVue } from 'ui.vue';

const app = BitrixVue.createApp({
	template: '<messages-component/>'
});
app.mount('MessagesComponent');